import {
  selectBundlePaymentPlansInitLoading,
  selectMySubscriptionsInitLoading,
} from 'domains/account/store/selectors';
import { useAccount } from 'modules/account/hooks/useAccount';
import { useAccountStatusTransition } from 'domains/account/hooks/useAccountStatusTransation';
import { useAppSelector } from 'store/useAppSelector';
import { useAuth } from 'modules/auth/hooks/useAuth';
import { useChargingModel } from 'modules/billing/hooks/useChargingModel';
import { useMenu } from 'modules/common/hooks/useMenu';
import { useMyBundles } from 'modules/billing/hooks/useMyBundles';
import { useMyBundlesStatus } from 'modules/billing/hooks/useMyBundlesStatus';

export const useBalanceMenuButton = () => {
  const { isLoggedIn } = useAuth();
  const { isAccountInitializing } = useAccount();
  const { hasAccountStatusTransition } = useAccountStatusTransition();

  const { data: myBundles, isLoading: myBundlesLoading } = useMyBundles();
  const myBundlesFetching = myBundlesLoading && myBundles === undefined;

  const { data: myBundlesStatus, isLoading } = useMyBundlesStatus();
  const myBundlesStatusLoading = isLoading && myBundlesStatus === undefined;

  const isBundlePaymentPlansLoading = useAppSelector(
    selectBundlePaymentPlansInitLoading,
  );
  const isMySubscriptionsLoading = useAppSelector(
    selectMySubscriptionsInitLoading,
  );

  const chargingModel = useChargingModel();
  const {
    anchorEl,
    handleClose,
    handleOpen,
    open: isBalanceMenuOpened,
  } = useMenu();

  return {
    anchorEl,
    chargingModel,
    handleClose,
    handleOpen,
    hasStatusTransition: hasAccountStatusTransition,
    isBalanceMenuOpened,
    isLoading:
      isAccountInitializing ||
      myBundlesStatusLoading ||
      isBundlePaymentPlansLoading ||
      myBundlesFetching ||
      isMySubscriptionsLoading,
    isLoggedIn,
  };
};
